import request from "api/request";

export const getCooperationTypes = async () => {
  return await request.get(`/Vendor/Management/GetCooperationType`);
};

export const getPharmacyType = async () => {
  return await request.get(`/Vendor/Management/GetPharmacyType`);
};

export const createVendor = async (body) => {
  return await request.post(`/Vendor/Management/Create`, body, { isFormData: true });
};
